import React, { Fragment, useState, useEffect, useContext } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import records from '../../../Services/records'
import Tabs, { TabPane } from "rc-tabs";
import { appContext } from "../../../Utils/context";
import TabContent from "rc-tabs/lib/TabContent";
import ScrollableInkTabBar from "rc-tabs/lib/ScrollableInkTabBar";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import OwnerDetail from "./OwnerDetail";
import PropertyDetail from "./PropertyDetail";
import ActivityLog from "./ActivityLog"
import LeadInfo from "./LeadInfo";
import Head from "./Head";
import RightSide from "./RightSide";
import Notes from "./Notes";
import Tags from "./Tags";
import {
  Row,
  Col
} from "reactstrap";
import Lists from "./Lists";

export default function RecordsDetailed({ address_id, list, setList }) {
  const { setTagsData, tagsData, setTasksData, setManualAdd} = useContext(appContext)
  const [data, setData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [tabKey, settabKey] = useState(null)
  const [tasks, setTasks] = useState([])
  const [newTags, setNewTags] = useState()
  //const {address_id} = useParams()
  // console.log("data.uatID", data.uat_id)4
  // console.log("Adddress Id", address_id)
  useEffect(()=>{
    if(address_id !== undefined && address_id !== null){
    setTagsData(newTags)}
  },[newTags])

  useEffect(()=>{
    if(address_id !== undefined && address_id !== null){
    setTasksData(tasks)}
  },[tasks])

  useEffect(() => {
    if (address_id !== undefined) {
      setIsLoading(true)
      let isMounted = true;
      records.details({uat_id:address_id}).then((res) => {
        if (isMounted) {
          setData(res.data)
        }
      }).catch((err) => {
        console.log("error is", err)
      }).finally(() => setIsLoading(false))
      return () => { isMounted = false };
    }else{
      setData({
          people:[{
            title:'',
            age:'',
            first_name:'',
            last_name:'',
            middle_name:'',
            suffix:'',
            addresses:[{
              zip:'',
              city:'',
              state:'',
              address1:'',
          }]
        }]
      })
    }
  }, [])

  useEffect(() => {
    if (data?.uat_id !== undefined) {
        setIsLoading(true)
        let isMounted = true;
        records.getNewTags(data?.uat_id).then((res) => {
                if (isMounted) {
                setNewTags(res.data)}
            }).catch((err) => {
                console.log("error is ", err)
            }).finally(() => setIsLoading(false))
            return () => { isMounted = false };
    }else
    {
      setManualAdd(data)
    }
}, [data])

useEffect(() => {

  if(address_id !== undefined){
    records.getTask({uat_id:address_id}).then((res) => {
         setTasks(res.data)
         // console.log("Notes are", res.data)
      }).catch((err) => {
          console.log("error is", err)
      })
  }
  
},[address_id])

  const changeTab = (key) => {

    settabKey(key)
  }

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition component="div" classNames="TabsAnimation" appear={true}
          timeout={1500} enter={false} exit={false}>
          <div >
            {isLoading ? (
              <>
                <Row>
                  <Col md="12"><Skeleton height={90} /></Col>
                </Row>
                <Row className="g-2">
                  <Col md="5">
                    <Row className="mb-2 g-4 mt-1">
                      <Col xs="3"><Skeleton height={30} /></Col>
                      <Col xs="3"><Skeleton height={30} /></Col>
                      <Col xs="3"><Skeleton height={30} /></Col>
                      <Col xs="3"><Skeleton height={30} /></Col>
                    </Row>
                    <Skeleton height={180} count={2} /></Col>
                  <Col md="4">
                    <Row className="mb-2 g-4 mt-1 ms-2">
                      <Col xs="4"><Skeleton height={30} /></Col>
                      <Col xs="4"><Skeleton height={30} /></Col>
                    </Row>
                    <Skeleton height={220} count={2} />
                  </Col>
                  <Col md="3">
                    <Row >
                      <Col md="12" className="mt-1"> <Skeleton height={70} /></Col>
                    </Row>
                    <Skeleton height={140} count={2} />

                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <Col md="12">
                    <Head newTags={newTags} setNewTags={setNewTags} list={list} setList={setList} uatId={data.uat_id} data={data} setData={setData} />
                    </Col>
                </Row>
                <Row className="g-2 mt-0" style={{ backgroundColor: "#f8f9fa" }}>
                  <Col md="5">
                    <Row className="g-0">
                      <Col md="12">
                        <Tabs defaultActiveKey="1" onChange={changeTab} renderTabBar={() => <ScrollableInkTabBar />} renderTabContent={() => <TabContent />}>
                          <TabPane tab="CONTACT INFO" key="1">
                            <OwnerDetail data={data} setData={setData} recordId={address_id} />
                          </TabPane>
                          <TabPane tab="PROPERTY INFO" key="2">
                            <PropertyDetail data={data} />
                          </TabPane>
                          <TabPane tab="LOGS" key="3" disabled={address_id === undefined}>
                            <ActivityLog uatId={data.uat_id} tabKey={tabKey} list={list} tasks={tasks} />
                          </TabPane>
                          <TabPane tab="LEAD INFO" key="4" disabled={address_id === undefined}>

                            <LeadInfo data={data} />
                          </TabPane>
                        </Tabs>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="4">
                    <Row>
                      <Col md="12">
                        <Tabs defaultActiveKey="1" renderTabBar={() => <ScrollableInkTabBar />} renderTabContent={() => <TabContent />}>
                          <TabPane tab="NOTES" key="1">
                            <Notes uatId={data.uat_id} list={list} setList={setList} />
                          </TabPane>
                          <TabPane tab="TAGS" key="2">
                            <Tags newTags={newTags} setNewTags={setNewTags} uatId={data.uat_id}  setList={setList} list={list} />
                          </TabPane>
                          <TabPane tab="LISTS" key="3">
                            <Lists newTags={newTags} setNewTags={setNewTags} uatId={data.uat_id} setList={setList} list={list} />
                          </TabPane>
                        </Tabs>
                      </Col>
                    </Row>



                  </Col>
                  <Col md="3">
                    <RightSide newTags={newTags} setNewTags={setNewTags} uatId={data.uat_id} setList={setList} list={list} tasks={tasks} setTasks={setTasks} />
                  </Col>
                </Row>
              </>
            )}

          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );

}
